
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className='title'>Comment les zones de dangers sont délimitées</div>
    <p>{`Un territoire est classé en zone de danger selon la fréquence et l’intensité des événements qui peuvent s’y produire. On utilise pour ce faire un diagramme d’intensité/probabilité:`}</p>
    <div className='imageContainer'>
  <img className='visual' src='images/matrix_fr.svg' width='250px' />
    </div>
    <b>L’intensité </b><br />permet de distinguer entre les processus graduels, comme la lente montée d’un lac après de fortes pluies, et des événements brutaux, comme l’effondrement d’une falaise ou la crue soudaine d’un ruisseau de montagne.
    <b>La probabilité</b><br />distingue entre les événements susceptibles de se produire tous les 30, 100 ou 300 ans. Une zone peut être classée en danger élevé même si l’événement qui la menace, par exemple une inondation, ne risque de se produire que tous les 300 ans.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;